import {ReportData} from "../../../reports/report.data";
import {collection, field} from "@fedeltapointofsale/data-client";
import {InventoryReportSelectionData} from "../../inventory/controls/inventory-report-selection-control.component";
import {SupplierReportSelectionData} from "../../supplier/controls/supplier-report-selection-control.component";

export class StockValuationReportData extends ReportData<StockValuationReportData> {
    @field reportType: string = "INVENTORY_GROUP";
    @field exclusive: boolean = true;
    @collection() groupBy: string[] = ["none"];
    @collection(InventoryReportSelectionData) inventories: InventoryReportSelectionData[];
}
